import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Footer from "../Components/Footer";
import Menubar from "../Components/Menubar";
import Totop from "../Components/Totop";
import ProductShowcase from "./ProductShowcase";
import "./Rpm.css";
import "../../index.css";
import { MediaQueryContext } from "../../context";
import serviceimg3 from "../../assets/images/03rpm/service3_card_fit.png";
import riskPredictionImg from "../../assets/images/03rpm/risk_prediction.svg";

const renderMultiline = (text) =>
  text.split("\n").map((line, i, arr) => (
    <React.Fragment key={i}>
      {line}
      {i < arr.length - 1 && <br />}
    </React.Fragment>
  ));

const Healthcare = (props) => {
  const { mTablet } = useContext(MediaQueryContext);
  const { t } = useTranslation();

  const executeScroll = () => {
    const element = document.getElementById(props.location.hashId);
    const headOffset = mTablet ? 84 : 184;
    const elementPosition = element?.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - headOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    executeScroll();
  }, [props.location.update]);

  const serviceItems = [
    {
      key: "healiary",
      img: serviceimg3,
      detailKey: "healiary",
      site: "https://www.healiary.com/",
      appStore: "https://apps.apple.com/kr/app/id1636424503",
      play: "https://play.google.com/store/apps/details?id=com.herings.healiary",
    },
    { key: "riskPrediction", img: riskPredictionImg },
  ];

  return (
    <div id="healthcare">
      <Menubar slideIndex={0} />
      <Totop />
      <div className="rpm-main-container">
        <div className="rpm-container1">
          <div className="rpm-section1-text-layout">
            <span className="rpm-section1-maintext">
              {renderMultiline(t("healthcare.hero.title"))}
            </span>
            <span className="rpm-section1-subtext">
              {renderMultiline(t("healthcare.hero.subtitle"))}
            </span>
          </div>
        </div>
        <div className="rpm-section4-layout-bg">
          <div className="rpm-section4-layout">
            <div>
              <p className="rpm-section4-maintext">
                {t("healthcare.services.title")}{" "}
                <span style={{ color: "#F68C29" }}>
                  {t("healthcare.services.highlight")}
                </span>{" "}
                {t("healthcare.services.titleAfter")}
              </p>
            </div>
            <ProductShowcase ns="healthcare" items={serviceItems} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Healthcare;
